import { postRequest } from "components/Common/Utils";
import React, { useState, useEffect } from "react";
// import Swal from "sweetalert2/dist/sweetalert2.js";
import { ToastContainer, toast } from "react-toastify";
import "sweetalert2/src/sweetalert2.scss";
import Swal from "sweetalert2/dist/sweetalert2.js";


const SettingManage = () => {
    const [data, setData] = useState([]);
    const [editingIndex, setEditingIndex] = useState(null);
    const [instructionid, setInstructionId] = useState('');
    const [editingInstruction, setEditingInstruction] = useState(null);
    const [newInstruction, setNewInstruction] = useState({ title: "", status: "active", steps: [""] });
    const [openInstruction, setopenInstruction] = useState(false);

    const fetchInstrucation = async () => {
        try {
            const response = await postRequest('setting/get-setting');
            if (response?.status) {
                const resp = response?.data;
                setData(resp.instructionList.map((instruction) => ({
                    title: instruction.title,
                    instructionId: instruction._id,
                    status: instruction.status,
                    steps: instruction.steps,
                })));
            }
        } catch (error) {
            console.log('please contact to kulies');
        }
    };

    useEffect(() => {
        fetchInstrucation();
    }, []);

    const handleAdd = () => {
        setopenInstruction(true);
        // alert('demo')
    };
    const handleEdit = (index) => {
        setEditingIndex(index);
        setEditingInstruction({ ...data[index] });
    };
    const handlerdelete = (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You want to delete this Instruction",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        }).then((result) => {
            if (result.isConfirmed) {
                deleteRequestFunction(id);
            }
        });
    };


    const deleteRequestFunction = async (id) => {
        const response = await postRequest("setting/remove-instruction", { instructionId: id });
        if (response.status) {
            Swal.fire("Deleted!", "Deleted successfully");
            fetchInstrucation();
        } else {
            Swal.fire("Error!", "Something went wrong");
        }
    };

    const handleUpdateChange = (key, value) => {
        setEditingInstruction((prev) => ({ ...prev, [key]: value }));
    };

    const handleUpdateStep = (stepIndex, value) => {
        const updatedSteps = [...editingInstruction?.steps];
        updatedSteps[stepIndex] = value;
        handleUpdateChange('steps', updatedSteps);
    };

    const handleAddStep = () => {
        const updatedSteps = [...editingInstruction?.steps, ''];
        handleUpdateChange('steps', updatedSteps);
    };

    const handleRemoveStep = (stepIndex) => {
        const updatedSteps = editingInstruction?.steps.filter((_, i) => i !== stepIndex);
        handleUpdateChange('steps', updatedSteps);
    };

    const handleSaveUpdate = async () => {
        const updatedData = [...data];
        updatedData[editingIndex] = editingInstruction;
        try {
            if(updatedData[editingIndex].title === ''){
             toast.warn("Plese select type");
              return
            }
            if(updatedData[editingIndex].status === ''){
             toast.warn("Plese select status");
              return
            }
            const response = await postRequest('setting/update-instruction', updatedData[editingIndex]);
            if (response?.status) {
                setopenInstruction(false);
                toast.success("Instruction updated successfully.");
                setData(updatedData);
                setEditingIndex(null);
                setEditingInstruction(null);
            }
            else {
                toast.warn(response?.message);
            }
        } catch (error) {
            toast.error(response?.message);
        }
    };

    const handleAddInstructionChange = (key, value) => {
        setNewInstruction((prev) => ({ ...prev, [key]: value }));
    };

    const handleAddNewStep = () => {
        const updatedSteps = [...newInstruction.steps, ''];
        handleAddInstructionChange('steps', updatedSteps);
    };

    const handleRemoveNewStep = (stepIndex) => {
        const updatedSteps = newInstruction.steps.filter((_, i) => i !== stepIndex);
        handleAddInstructionChange('steps', updatedSteps);
    };

    const handleAddInstruction = async () => {
        try {
            const response = await postRequest('setting/add-instruction', newInstruction);
            if (response?.status) {
                setopenInstruction(false);
                setData((prevData) => [...prevData, { ...newInstruction, instructionid: response.data._id }]);
                setNewInstruction({ title: "", status: "", steps: [""] });
                toast.success("Instruction Added successfully.");
            }
            else {
                toast.error(response?.message);
            }
        } catch (error) {
            toast.error("Please try again..");
        }
    };


    return (
        <div className="setting-page">
            <ToastContainer />
            <div className="row">
                <div className="col-md-6">
                    <div className="page-title-box">
                        <h4>Setting Management</h4>
                        <ol className="breadcrumb m-0">
                            <li className="breadcrumb-item active">Setting Management</li>
                            <li className="breadcrumb-item">Instructions Setting</li>
                        </ol>
                    </div>
                </div>

            </div>

            <div className="card">
                <div className="card-body">
                    <div className="col-md-12 mb-2 text-end">
                        {!openInstruction && editingIndex == null ? <>
                            {/* <button
                                type="button"
                                onClick={() => handleAdd()}
                                className="btn btn-primary"
                            > <i class="fas fa-plus"></i> Create
                            </button> */}
                        </> : <>
                            <button
                                type="button"
                                onClick={() => { setopenInstruction(false), setEditingIndex(null) }}
                                className="btn btn-secondary"
                            > <i class="fas fa-chevron-left"></i> Back
                            </button>
                        </>}
                    </div>
                    {openInstruction ?
                        <div>
                            <h4>Add New Instruction</h4>
                            <div>
                                <label>
                                    Title:
                                    <select
                                        className="form-control"
                                        value={newInstruction?.title}
                                        onChange={(e) => handleAddInstructionChange('title', e.target.value)}
                                    >
                                        <option value=''>Please Select..</option>
                                        <option value="bankDeposit">Bank Deposit</option>
                                        <option value="cod">COD</option>
                                        <option value="payNow">Pay Now</option>
                                    </select>
                                </label>
                            </div>
                            <div>
                                <label>
                                    Status:
                                    <select
                                        className="form-control"
                                        value={newInstruction?.status}
                                        onChange={(e) => handleAddInstructionChange('status', e.target.value)}
                                    >    
                                        <option value="active">Active</option>
                                        <option value="inactive">Inactive</option>
                                    </select>
                                </label>
                            </div>
                            <div>
                                <label>Steps:</label>
                                {newInstruction?.steps.map((step, index) => (
                                    <div key={index} className="d-flex gap-2">
                                        <input
                                            className="form-control mt-2"
                                            type="text"
                                            value={step}
                                            onChange={(e) => {
                                                const updatedSteps = [...newInstruction.steps];
                                                updatedSteps[index] = e.target.value;
                                                handleAddInstructionChange('steps', updatedSteps);
                                            }}
                                        />
                                        <button
                                            className="btn btn-danger" style={{ height: '34px', marginTop: '9px' }}
                                            onClick={() => handleRemoveNewStep(index)}
                                        >
                                            Remove
                                        </button>
                                    </div>
                                ))}
                                <button className="btn btn-secondary mt-2" onClick={handleAddNewStep}>
                                    Add Step
                                </button>
                            </div>
                            <div className="mt-3">
                                <button className="btn btn-primary" style={{ marginRight: '10px' }} onClick={handleAddInstruction}>
                                    Save
                                </button>
                                <button className="btn btn-secondary" onClick={() => setopenInstruction(false)}>
                                    Cancel
                                </button>
                            </div>
                        </div> :
                        <>
                            {editingIndex !== null ? (
                                <div>
                                    <h4 className="mb-4 mt-3">Edit Instruction</h4>
                                    <div>
                                        <label>
                                            Select Type
                                            {/* <input
                                                    className="form-control"
                                                    type="text"
                                                    value={editingInstruction?.title}
                                                    onChange={(e) => handleUpdateChange('title', e.target.value)}
                                                /> */}
                                            <select
                                                disabled
                                                className="form-control"
                                                value={editingInstruction?.title}
                                                onChange={(e) => handleUpdateChange('title', e.target.value)}
                                            >
                                                <option value=''>Please Select..</option>
                                                <option value="bankDeposit">Bank Deposit</option>
                                                <option value="cod">COD</option>
                                                <option value="payNow">Pay Now</option>
                                            </select>
                                        </label>
                                    </div>
                                    <div>
                                        <label>
                                            Status:
                                            <select
                                                className="form-control"
                                                value={editingInstruction?.status}
                                                onChange={(e) => handleUpdateChange('status', e.target.value)}
                                            >
                                                <option value="active">Active</option>
                                                <option value="inactive">Inactive</option>
                                            </select>
                                        </label>
                                    </div>
                                    <div>
                                        <label>Steps:</label>
                                        {editingInstruction?.steps?.map((step, index) => (
                                            <div key={index} className="d-flex gap-2 align-items-center mb-3">
                                                <input
                                                    className="form-control mt-2"
                                                    type="text"
                                                    value={step}
                                                    onChange={(e) => handleUpdateStep(index, e.target.value)}
                                                />
                                                <button style={{ height: '34px', marginTop: '9px' }}
                                                    className="btn btn-danger"
                                                    onClick={() => handleRemoveStep(index)}
                                                >
                                                    Remove
                                                </button>
                                            </div>
                                        ))}
                                        <button className="btn btn-secondary mt-2" onClick={handleAddStep}>
                                            Add Step
                                        </button>
                                    </div>
                                    <div className="mt-3">
                                        <button className="btn btn-primary" style={{ marginRight: '10px' }} onClick={handleSaveUpdate}>
                                            Save Changes
                                        </button>
                                        <button className="btn btn-secondary" onClick={() => setEditingIndex(null)}>
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            ) : (
                                <div className="react-bootstrap-table">
                                    <table className="table table-bordered table-striped">
                                        <thead>
                                            <tr>
                                                <th>S.NO</th>
                                                <th>Type</th>
                                                <th>Status</th>
                                                <th>Steps</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{item?.title}</td>
                                                    <td>{item?.status}</td>
                                                    <td className="text-start" style={{ width: '50%' }}>
                                                        <ul>
                                                            {item?.steps.map((step, stepIndex) => (
                                                                <li key={stepIndex}>{step}</li>
                                                            ))}
                                                        </ul>
                                                    </td>
                                                    <td>
                                                        <div className="d-flex justify-content-center gap-2">
                                                            <button
                                                                className="btn btn-primary"
                                                                onClick={() => {
                                                                    handleEdit(index);
                                                                }}
                                                            >
                                                                <i className="fal fa-edit fs-5 text-light"></i>
                                                            </button>
                                                            {/* <button
                                                                type="button"
                                                                className="btn btn-danger"
                                                                onClick={() => handlerdelete(item?.instructionId)}
                                                            >
                                                                <i className="fal fa-trash  fs-5"></i>
                                                            </button> */}
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </>}

                </div>
            </div>
        </div>
    );
};
export default SettingManage;
